define(
    [
        'core/urls',
        'moment',
        'core/browser-storage',
        'components/modal',
        'components/preview-flow',
        'components/pagination',
        'components/search-field',
        'components/fake-progress',
        'components/dropdown',
        'components/request-time-manager',
        'components/custom-encode-uri',
        'core/utilities',
        'components/metrics',
        'air-datepicker',
        'air-datepicker/locale/en',
        
    ],
    function (
        urls, 
        moment, 
        browser_storage, 
        modal, 
        preview,
        initPagination, 
        initSearchField, 
        FakeProgress, 
        DD, 
        requestTM,
        customEncodeUri,
        utilities,
        keyMetrics,
        AirDatepicker,
        localeEn
    ) 
    {

        let nodes = {
            pageWrapper: document.querySelector(".nps-campaigns"),
            campaignWrapper: document.querySelector(".campaign-wrapper"),
            activeCampaign: document.querySelector(".campaign-wrapper .active-campaign"),
            noCampaignsWrap: document.querySelector(".campaign-wrapper .no-campaigns"),
            surveyDeployedWrap: document.querySelector(".campaign-wrapper .survey-deployed"),
            noSurveyDeployedWrap: document.querySelector(".campaign-wrapper .no-survey-deployed"),
            campaignSelector: document.querySelector(".campaign-wrapper .campaign-selector"),
            contactsLimitSelector: document.querySelector(".nps-campaign-custom-limit_js"),
            contactListSelector:  document.querySelector(".contact-list-selector"),
            settingsToggle: document.querySelector(".settings-toggle-wrap"),
            contactsTableWrap: document.querySelector(".contacts-table-wrap"),
            timezone: document.querySelector(".timezone"),
            deleteModal: document.querySelector(".modal-delete-campaign"),
            connectionErrorModal: document.querySelector(".modal-template-error_js"),
            rescheduleModal: document.querySelector(".modal-template.reschedule"),
            campaignData: {
                surveyStatus: document.querySelector(".active-campaign .survey-status"),
                surveysSent: document.querySelector(".active-campaign .surveys-sent .card__main-score"),
                surveyResponseCount: document.querySelector(".active-campaign .response-count .card__main-score"),
                surveyResponseRate: document.querySelector(".active-campaign .response-rate .card__main-score"),
                surveyLastSentDate: document.querySelector(".active-campaign .last-sent .card__main-score .date"),
                surveyLastSentTime: document.querySelector(".active-campaign .last-sent .card__main-score .time"),
                surveyNextScheduleCard: document.querySelector(".active-campaign .next-scheduled .card__main-score"),
                surveyNextScheduleDate: document.querySelector(".active-campaign .next-scheduled .card__main-score .date"),
                surveyNextScheduleTime: document.querySelector(".active-campaign .next-scheduled .card__main-score .time"),
            },
            settingsPanel: document.querySelector(".settings-panel"),
            campaignSettings: {
                parent: document.querySelector(".campaign-settings"),
                name: document.querySelector(".campaign-settings .campaign-name"),
                nameStaticWrap: document.querySelector(".campaign-settings .campaign-name-static"),
                nameStaticText: document.querySelector(".campaign-settings .campaign-name-static"),
                nameInputWrap: document.querySelector(".campaign-settings .name-input-wrap"),
                nameInput: document.querySelector(".campaign-settings .campaign-name-input"),
                nameError: document.querySelector(".campaign-settings .campaign-name-wrap .error"),
                activeStatusWrap: document.querySelector(".campaign-settings .active-status-wrap"),
                activeToggle: document.querySelector(".campaign-settings #activeStatus"),
                activeLabel: document.querySelector(".campaign-settings .active-status-label"),
                completeLabel: document.querySelector(".campaign-settings .complete-wrap"),
                repeatFrequency: document.querySelector(".campaign-settings .repeat-frequency"),
                repeatFrequencySelector: document.querySelector(".campaign-settings .repeat-frequency-selector"),
                resendToggle: document.querySelector(".campaign-settings #autoResend"),
                resendFrequency: document.querySelector(".campaign-settings .resend-frequency-selector"),
                marketingPermissionsToggle: document.querySelector(".campaign-settings #marketingPermissions"),
                googleToggle: document.querySelector(".campaign-settings #googleReviews"),
                googleOptionToggles: document.querySelectorAll(".google-response-option"),
                googleTogglePromoterToggle: document.querySelector(".campaign-settings #promoter_responses"),
                googleTogglePassiveToggle: document.querySelector(".campaign-settings #passive_responses"),
                googleToggleDetractorToggle: document.querySelector(".campaign-settings #detractor_responses"),
                googleUrl: document.querySelector(".campaign-settings .google-url"),
                googleUrlWrap: document.querySelector(".campaign-settings .google-url-wrap"),
                googleStaticWrap: document.querySelector(".campaign-settings .google-url-static"),
                googleStaticText: document.querySelector(".campaign-settings .google-url-static .google-url"),
                googleError: document.querySelector(".campaign-settings .google-url-wrap .error"),
                googleInputWrap: document.querySelector(".campaign-settings .google-input-wrap"),
                googleInput: document.querySelector(".campaign-settings .google-url-input"),
                saveButton: document.querySelector(".campaign-settings .save-changes"),
                deleteButton: document.querySelector(".campaign-settings .delete"),
                lockedControlsWrap: document.querySelector(".campaign-settings .locked-campaign-controls"),
                viewSurveyButton: document.querySelector(".campaign-settings .view-survey"),
                editCampaignButton: document.querySelector(".campaign-settings .edit-campaign"),
                reviewContactsButton: document.querySelector(".campaign-settings .review-contacts"),
                rescheduleWrapper: document.querySelector(".campaign-settings .reschedule-wrapper"),
                settingsNextScheduleDate: document.querySelector(".campaign-settings .reschedule-wrapper .next-schedule"),
                rescheduleLink: document.querySelector(".campaign-settings .reschedule-wrapper a.reschedule"),
            },
            searchField: {
                searchField: document.querySelector(".search-response_js"),
                resetBtn: document.querySelector(".search-response-reset_js"),
                openBtn: document.querySelector(".search-response-open_js"),
                wrap: document.querySelector(".results-search-wrap_js")
            },
            pagination: {
                wrap: document.querySelector(".pagination_js"),
                page: document.querySelector(".pagination_page_js"),
                hole: document.querySelector(".pagination_hole_js")
            },
            previewModal: {
                wrapper: document.querySelector(".preview_js"),
                closeButton: document.querySelector(".preview-close_js"),
                steps: document.querySelector(".preview-steps_js"),
                content: document.querySelector(".preview-content_js"),
            },
            modal: {
                modal: document.querySelector(".modal_js"),
                close: document.querySelector(".modal-close_js"),
                content: document.querySelector(".modal-content_js"),
                title: document.querySelector(".modal-title_js"),
                bg: document.querySelector(".modal-bg_js"),
                blur: [
                    document.querySelector(".nps-campaigns"),
                    document.querySelector(".sidebar-nav"),
                    document.querySelector(".navigation-top")
                ],
            },
            deleteModalTemplate: document.querySelector(".modal-delete-campaign"),
            metrics: {
                main: document.querySelector(".metrics-header-wrap.global"),
                wrap: document.querySelector(".metrics-wrap"),
                metricsContainer: document.querySelector(".metrics-wrap .metrics"),
                header: document.querySelector(".page-header.metrics"),
            },
        };

        let csrfToken = document.querySelector("[name='csrfmiddlewaretoken']").value;

        let metrics = keyMetrics.init(nodes.metrics, "survey-results");
        metrics.adjustMetricsHeight();
        window.addEventListener("resize", metrics.adjustMetricsHeight);

        var createdModal = modal.create(nodes.modal, () => {});

        let dataTimeManager = new requestTM();
        let loaderElement = document.querySelector(".marketing-loader");
        let loaderHint = loaderElement.querySelector(".loader-bar-wrap_hint");
        let DDRepeatFrequencySelector;
        let DDResendFrequencySelector;
        let settingsHeight = '';
        let previewModal = '';
        let saveDisabled = true;
        let searchField;
        let pagination;

        loaderHint.innerText = "Your results are loading. Please wait.";
        
        let loadingScreen = new FakeProgress(
            document.querySelector(".marketing-loader .loader-bar-wrap-bar")
        );

        let previousContactList = 'active';

        let initialSorting = {
            q: "",
            limit: 10,
            page: 1,
            sort: {full_name: "asc"},
            contacts: 'active',
        }

        let campaignSorting = initialSorting;

        let currentCampaign = '';
        let currentCampaignData;
        let initalFollowingDate;

        const getCampaign = (id, callback) => {

            dataTimeManager.start((error) => {
                loaderElement.classList.add("disabled");
                loadingScreen.loadFinish();
                createdModal.open({
                    class: "error-modal",
                    content: nodes.connectionErrorModal.innerHTML,
                    title: ""
                }, function (el) {
                    el.querySelector(".button-primary").addEventListener("click", createdModal.close);
                });
            });

            loadingScreen.reset();
            loaderElement.classList.remove("disabled");
            loadingScreen.startLoading(15);

            function request() {
                let xhr = new XMLHttpRequest();
                let url = `${urls['nps:campaign_view'](id)}?data=${encodeURIComponent(JSON.stringify(campaignSorting))}`;
                xhr.open("GET", url, true);
                dataTimeManager.addXHR(xhr);
                xhr.setRequestHeader("Content-Type", "application/json");

                xhr.onreadystatechange = function () {
                    let data = {};
                    try {
                        data = JSON.parse(xhr.responseText);
                    } catch (e) {
                        data = {success: false};
                    }

                    switch (true) {
                        case xhr.status === 500:
                            loaderElement.classList.add("disabled");
                            loadingScreen.loadFinish();
                            dataTimeManager.abort();
                            break;

                        case xhr.status === 0:
                            data = {success: false};
                            return;
                        
                        case xhr.status === 424:
                            data = {success: false};
                            createdModal.open({
                                class: "error-modal",
                                content: nodes.connectionErrorModal.innerHTML,
                                title: ""
                            }, function (el) {
                                el.querySelector(".button-primary").addEventListener("click", createdModal.close);
                            });
                            loadingScreen.loadFinish();
                            dataTimeManager.abort();
                            return;

                        case xhr.status !== 200:
                            data = {success: false};
                            break;
                    }

                    if (data.success) {                
                        dataTimeManager.abort({success: true});
                        loaderElement.classList.add("disabled");
                        loadingScreen.loadFinish();
                        currentCampaign = id;   
                        currentCampaignData = data;
                        renderCampaign(data);
                        createSurveyPreview();
                        
                        editSaveState(true);

                        if(browser_storage.getItem("campaign-saved") === "true") {
                            let notification = document.querySelector(".notification");
                            notification.classList.add("active");
            
                            setTimeout(() => {
                                notification.classList.remove("active");
                            }, 4000)

                            browser_storage.setItem("campaign-saved", false);
                        }

                        if(callback) callback(data);

                        browser_storage.setItem("last-visited-campaign", currentCampaign);
                    }

                    // campaign stored in browser_storage no longer exists. Get the latest campaign instead
                    if(data.reason === "Not Found") { 
                        getLatestCampaign();
                        return;
                    }
                };
                xhr.send();
            };
            dataTimeManager.interval(request);
        }

        const getAllCampaigns = () => JSON.parse(nodes.pageWrapper.getAttribute("data-campaigns"));

        const getLatestCampaign = () => {
            let firstCampaignId = getAllCampaigns()[0].pk;  
            getCampaign(firstCampaignId);
        }

        const tableConfig = {
            "active": [
                {   
                    readableTitle: "Contact Name",
                    className: "full-name",
                    dataProperty: "full_name",
                    sortable: true,
                    sorted: true,
                    customOutput: (contact) => utilities.sanitizeData(contact.full_name),
                },
                {   
                    readableTitle: "Company",
                    className: "company",
                    dataProperty: "company",
                    sortable: true,
                    sorted: false,
                    customOutput: (contact) => utilities.sanitizeData(contact.company)
                },
                {
                    readableTitle: "Survey sent",
                    className: "survey-sent",
                    dataProperty: "survey_sent",
                    sortable: false,
                    sorted: false,
                    customOutput: (contact) => contact.unsubscribed ? "<span class='error-red'>Unsubscribed</span>" : "Yes",
                },
                {
                    readableTitle: "Responded",
                    className: "responded",
                    dataProperty: "responded",
                    sortable: true,
                    sorted: false,
                    customOutput: (contact) => contact.responded ? "Yes" : "<span class='error-red'>No</span>",
                },
                {
                    readableTitle: "",
                    className: "controls",
                    dataProperty: "controls",
                    sortable: false,
                    sorted: false,
                    customOutput: (contact, data) => {
                        let disabled = contact.unsubscribed || contact.responded;
                        let emailButton = '';

                        // don't render email button for those who have already used it in the current survey
                        if(data.manual_recipients.includes(contact.id)) {
                            emailButton = `
                                <div class="resend-email-wrap">
                                    <div data-id="${contact.id}" class="button-primary sent resend-email">
                                        Email re-sent
                                    </div>
                                </div>`
                        } else {
                            emailButton = `
                                <div class="tooltip-wrap resend-email-wrap ${disabled ? 'show-tooltip' : ''}">
                                    <div data-id="${contact.id}" class="button-primary resend-email ${disabled ? 'disabled' : ''}">
                                        Re-send email
                                    </div>
                                    <div class="sb-tooltip">
                                        Re-send functionality is only available for contacts who have not responded since the last deployment.
                                    </div>
                                </div>`
                        }
                        return `
                            ${emailButton}
                            <div data-id="${contact.id}" class="remove-contact tooltip-wrap">
                                <div class="icon glyphicons glyphicons-remove-sign"></div>
                                <div class="sb-tooltip">
                                    Exclude contact from all future deployments
                                </div>
                            </div>  
                            <div data-id="${contact.id}" class="remove-contact-confirm hide">
                                Exclude contact?
                                <div class="options">
                                    <span data-id="${contact.id}" class="yes">Yes</span>
                                    <span data-id="${contact.id}" class="no">No</span>
                                </div>
                            </div>  
                        `
                    }
                },
            ],
            "excluded": [
                {   
                    readableTitle: "Contact Name",
                    className: "full-name",
                    dataProperty: "full_name",
                    sortable: true,
                    sorted: true,
                },
                {   
                    readableTitle: "Company",
                    className: "company",
                    dataProperty: "company",
                    sortable: true,
                    sorted: false,
                },
                {
                    readableTitle: "",
                    className: "controls",
                    dataProperty: "controls",
                    sortable: false,
                    sorted: false,
                    customOutput: (contact, data) => {
                        return `
                            <div data-id="${contact.id}" class="button-primary add-contact">
                                Add contact to campaign
                            </div>
                        `
                    }
                },
            ],
            "unsubscribed": [
                {   
                    readableTitle: "Contact Name",
                    className: "full-name",
                    dataProperty: "full_name",
                    sortable: true,
                    sorted: true,
                },
                {   
                    readableTitle: "Company",
                    className: "company",
                    dataProperty: "company",
                    sortable: true,
                    sorted: false,
                },
            ]
        }

        const createTable = () => {
            // delete and re-render table if this function is called again
            let existingTable = document.querySelector(".contacts-table");
            if(existingTable) {
                existingTable.remove();
            }

            let contactsTable = document.createElement('table');
            contactsTable.classList.add("contacts-table", campaignSorting.contacts);

            let arrowHtml = '<img class="select-arrow-icon" src="/static/icons/down.svg" alt="">';

            const renderedHeaders = tableConfig[campaignSorting.contacts].map(config => {
                let title = '';
                if(config.readableTitle) {
                    title = config.sortable ? `${config.readableTitle} ${arrowHtml}` : config.readableTitle;
                }

                return `
                    <td 
                        class="${config.className} ${config.sorted ? 'active' : ''} ${config.sortable ? "sortable" : ''}" 
                        data-id="${config.dataProperty}">
                            ${title}
                    </td>`
            }).join('');

            const tableHtml = `
                <thead>
                    <tr>
                        ${renderedHeaders}
                    </tr>
                </thead>
                <tbody></tbody>`;

            contactsTable.innerHTML = tableHtml;

            nodes.contactsTableWrap.appendChild(contactsTable);

            contactsTable.querySelector("thead tr").addEventListener("click", (e) => {

                let el = e.target;
                let key = el.getAttribute("data-id");

                if (key && el.classList.contains("sortable")) {

                    let sortDirection = el.classList.contains("asc") ? 'desc' : 'asc';

                    let currentSortedColumn = document.querySelector(".contacts-table .sortable.active")
                    currentSortedColumn.classList.remove("active");

                    el.classList.add("active", sortDirection);
                    el.classList.remove(sortDirection === 'asc' ? 'desc' : 'asc');

                    campaignSorting.sort = {[key]: sortDirection};
                    getCampaign(currentCampaign);
                }
            });

            return contactsTable;
        }

        const renderContacts = (data) => {
            let output = '';
            let contacts = data.used_contacts;

            let noResults = document.querySelector(".table-results-wrap .no-results");

            if(contacts.length === 0) {
                noResults.classList.remove("hide");
                nodes.contactsTableWrap.classList.add("hide");
                return;
            }

            nodes.contactsTableWrap.classList.remove("hide");
            noResults.classList.add("hide");

            contacts.forEach(contact => {
                if(!data.campaign_info.excluded.includes(contact.id + "")) { // don't render excluded contacts
                    output += `<tr data-contact-id="${contact.id}">`;
                    output += tableConfig[campaignSorting.contacts].map(config => {
                        return `
                            <td class="${config.className}">
                                ${config.customOutput ? config.customOutput(contact, data): contact[config.dataProperty]}
                            </td>
                        `;
                    }).join('');
                    output += "</tr>";
                }
            });
            
            document.querySelector(".contacts-table tbody").innerHTML = output;

            document.querySelectorAll(".resend-email:not(.disabled)").forEach(node => {
                node.addEventListener("click", (event) => {
                    resendEmail(event.target.getAttribute("data-id"));
                })
            });

            if(campaignSorting.contacts === "active") {
                document.querySelectorAll(".remove-contact").forEach(node => {
                    node.addEventListener("click", (event) => {
                        event.currentTarget.classList.add("hide");
                        event.currentTarget.parentElement.querySelector(".remove-contact-confirm").classList.remove("hide");
                    })
                });
    
                document.querySelectorAll(".remove-contact-confirm .yes").forEach(node => {
                    node.addEventListener("click", (event) => {
                        addRemoveContact(event.target.getAttribute("data-id"), "remove");
                    })
                });
    
                document.querySelectorAll(".remove-contact-confirm .no").forEach(node => {
                    node.addEventListener("click", (event) => {
                        let id = event.target.getAttribute("data-id");
                        document.querySelector(`.remove-contact[data-id="${id}"]`).classList.remove("hide");
                        document.querySelector(`.remove-contact-confirm[data-id="${id}"]`).classList.add("hide");
                    })
                });
            }

            if(campaignSorting.contacts === "excluded") {
                document.querySelectorAll(".add-contact").forEach(node => {
                    node.addEventListener("click", (event) => {
                        addRemoveContact(event.target.getAttribute("data-id"), "add");
                    })
                })
            }
            
        }

        let validateSettings = () => {

            let isValid = true;
            var urlRegex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;

            if(!nodes.campaignSettings.nameInput.value) {
                nodes.campaignSettings.nameError.classList.remove("hide");
                isValid = false;
            } else {
                nodes.campaignSettings.nameError.classList.add("hide");
            }

            let showGoogleError = (errorMsg) => {
                nodes.campaignSettings.googleError.classList.remove("hide");
                nodes.campaignSettings.googleInputWrap.classList.remove("hide");
                nodes.campaignSettings.googleStaticWrap.classList.add("hide");
                nodes.campaignSettings.googleError.innerHTML = errorMsg;
                isValid = false;
            }

            if(nodes.campaignSettings.googleToggle.checked) {
                let responseOptions = document.querySelectorAll(".google-response-option");
                let hasCheckedOption = false;
                responseOptions.forEach(option => {
                    if (option.checked) hasCheckedOption = true
                });

                if (!hasCheckedOption) {
                    showGoogleError("Please select at least one Google Review option.");
                } else if (!nodes.campaignSettings.googleInput.value || !urlRegex.test(nodes.campaignSettings.googleInput.value)){
                    showGoogleError("Please enter a valid URL")
                } else {
                    nodes.campaignSettings.googleError.classList.add("hide");
                }
            }

            utilities.setSettingsHeight(nodes);

            return isValid;
        }

        const updateCampaign = (settings) => {
            if (saveDisabled) return;

            let xhr = new XMLHttpRequest();
            xhr.open("POST", urls['nps:campaign_partial_update'](currentCampaign));
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.setRequestHeader("X-CSRFToken", csrfToken)
            xhr.onreadystatechange = function () {
                if(xhr.status === 200) {
                    getCampaign(currentCampaign, () => {
                        nodes.campaignSettings.saveButton.classList.remove("loading");
                        editSaveState(true);
                    });
                }
            }

            if(!validateSettings()){
                return;
            }

            nodes.campaignSettings.saveButton.classList.add("loading");
            xhr.send(JSON.stringify(settings));
        }

        const deleteCampaign = () => {
            let xhr = new XMLHttpRequest();
            xhr.open("GET", urls['nps:campaign_remove'](currentCampaign));
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

            xhr.onreadystatechange = () => {
                if(xhr.status === 200) {
                    browser_storage.removeItem("last-visited-campaign");
                    window.location.reload();
                }
            }

            xhr.send();
        }

        const addRemoveContact = (id, action) => {
            // TO DO - update 'add contact' URL when ready
            let xhr = new XMLHttpRequest();
            xhr.open("GET", `${urls['nps:exclude_contact'](currentCampaign, id)}?operation=${action}`);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

            xhr.onreadystatechange = () => {
                let row = document.querySelector(`[data-contact-id="${id}"`);
                row.classList.add("deleted");

                setTimeout(() => {
                    row.remove();
                }, 300)

                let allRows = document.querySelectorAll(".contacts-table tbody tr:not(.deleted)");

                if(!allRows.length) {
                    setTimeout(() => {
                        document.querySelector(".table-results-wrap .no-results").classList.remove("hide");
                    }, 300)
                }
            }
            xhr.send();
        }

        const resendEmail = (id) => {
            let xhr = new XMLHttpRequest();
            xhr.open("GET", urls['nps:resend_survey'](currentCampaign, id));
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

            xhr.onreadystatechange = () => {
                let button = document.querySelector(`.resend-email[data-id="${id}"`)
                button.classList.add("sent");
                button.innerHTML = "Email sent";
            }

            xhr.send();
        }

        let disableInput = (eventTarget, disableTarget) => {
            eventTarget.checked ? disableTarget.classList.remove("disabled") : disableTarget.classList.add("disabled");
            
            let selectNode = disableTarget.querySelector("select");
            
            if(selectNode) {
                selectNode.disabled = !eventTarget.checked;
            }
        }

        const renderMetricsAndSettings = (data) => {
            nodes.settingsToggle.classList.remove("active");

            nodes.campaignData.surveysSent.innerHTML = data.campaign_info.surveys_sent || "N/A";
            nodes.campaignData.surveyResponseCount.innerHTML = data.campaign_info.collected_responses || "N/A";
            nodes.campaignData.surveyResponseRate.innerHTML = data.campaign_info.response_rate || "N/A";
            
            nodes.campaignData.surveyLastSentDate.innerHTML = moment.parseZone(data.campaign_info.sent_dates[0]).format('MMM DD, YYYY') || "N/A";
            nodes.campaignData.surveyLastSentTime.innerHTML = moment.parseZone(data.campaign_info.sent_dates[0]).format('LT') || "";

            nodes.campaignData.surveyNextScheduleDate.innerHTML = moment.parseZone(data.campaign_info.next_schedule).format('MMM DD, YYYY') || "N/A";
            nodes.campaignData.surveyNextScheduleTime.innerHTML = moment.parseZone(data.campaign_info.next_schedule).format('LT') || "";
            
            nodes.campaignSettings.name.innerHTML = utilities.sanitizeData(data.campaign_info.name);
            nodes.campaignSettings.nameInput.value = data.campaign_info.name;
            nodes.campaignSettings.nameStaticWrap.setAttribute("data-original-value", utilities.sanitizeData(data.campaign_info.name));
            nodes.campaignSettings.activeToggle.checked = data.campaign_info.is_active;
            nodes.campaignSettings.marketingPermissionsToggle.checked = data.campaign_info.marketing_permissions;
            nodes.campaignSettings.googleToggle.checked = data.campaign_info.google_reviews;
            nodes.campaignSettings.googleTogglePromoterToggle.checked = data.campaign_info.promoter_google_responses;
            nodes.campaignSettings.googleTogglePassiveToggle.checked = data.campaign_info.passive_google_responses;
            nodes.campaignSettings.googleToggleDetractorToggle.checked = data.campaign_info.detractor_google_responses;
            
            if(data.campaign_info.next_schedule) {
                nodes.campaignSettings.rescheduleWrapper.classList.remove("hide")
                nodes.campaignSettings.settingsNextScheduleDate.innerHTML = `Next scheduled survey: <strong>${moment.parseZone(data.campaign_info.next_schedule).format('MMM DD, YYYY')}</strong>`
            } else {
                nodes.campaignSettings.rescheduleWrapper.classList.add("hide")
            }

            nodes.timezone.querySelector("span").innerHTML = data.customer_tz;

            setActivePauseStatus(data.campaign_info.is_active, nodes.campaignSettings.activeLabel);
            setActivePauseStatus(data.campaign_info.is_active, nodes.campaignData.surveyStatus); 

            nodes.campaignSettings.resendToggle.checked = data.campaign_info.auto_resend;

            let contactsSource = data.campaign_info.source === 'tss' ? 'tss' : 'csv';
            let reviewContactsUrl = `${urls['nps:survey']()}?campaign=${currentCampaign}&source=${contactsSource}`;
            nodes.campaignSettings.reviewContactsButton.setAttribute("href", reviewContactsUrl)

            let repeatFrequency = data.campaign_info.repeat;
            let months = repeatFrequency > 1 ? `every ${repeatFrequency} months` : `every ${repeatFrequency} month`;

            let repeatMarkup = "";

            // users can only select repeat frequency if campaign is not locked
            if(data.campaign_info.locked) {
                repeatMarkup = repeatFrequency ? `Repeats ${months}` : "Repeats never";
                nodes.campaignSettings.repeatFrequencySelector.classList.add("hide"); 
                nodes.campaignSettings.repeatFrequencySelector.querySelector("select").disabled = true;
            } else {
                repeatMarkup = `Repeats `;
                nodes.campaignSettings.repeatFrequencySelector.classList.remove("hide");
                nodes.campaignSettings.repeatFrequencySelector.querySelector("select").disabled = false;
                DDRepeatFrequencySelector.chooseOption(data.campaign_info.repeat);
            }

            nodes.campaignSettings.repeatFrequency.innerHTML = repeatMarkup;
            
            DDResendFrequencySelector.chooseOption(data.campaign_info.resend_frequency || 1);
            
            if(data.campaign_info.google_reviews_url) {
                let url = data.campaign_info.google_reviews_url;
                nodes.campaignSettings.googleUrl.innerHTML = utilities.sanitizeData(url);
                nodes.campaignSettings.googleInput.value = url;
                nodes.campaignSettings.googleStaticWrap.setAttribute("data-original-value", url)
            } else {
                nodes.campaignSettings.googleUrl.innerHTML = "URL not entered";
                nodes.campaignSettings.googleInput.value = "";
                nodes.campaignSettings.googleStaticWrap.setAttribute("data-original-value", "")
            }

            data.campaign_info.google_reviews ? nodes.campaignSettings.googleUrlWrap.classList.remove("hide") : nodes.campaignSettings.googleUrlWrap.classList.add("hide");
            
            if (data.campaign_info.auto_resend) {
                nodes.campaignSettings.resendFrequency.classList.remove("disabled");
                nodes.campaignSettings.resendFrequency.querySelector("select").disabled = false;
            } else {
                nodes.campaignSettings.resendFrequency.classList.add("disabled");
                nodes.campaignSettings.resendFrequency.querySelector("select").disabled = true;
            }

            // if campaign is completed
            if(data.campaign_info.completed) {
                nodes.campaignSettings.activeStatusWrap.classList.add("hide");
                nodes.campaignSettings.completeLabel.classList.remove("hide");
                nodes.campaignSettings.resendToggle.parentElement.classList.add("disabled");
                nodes.campaignSettings.googleToggle.parentElement.classList.add("disabled");
                nodes.campaignSettings.marketingPermissionsToggle.parentElement.classList.add("disabled");
                nodes.campaignSettings.reviewContactsButton.classList.add("disabled");
                nodes.campaignData.surveyNextScheduleCard.classList.add("complete");
                nodes.campaignData.surveyNextScheduleDate.innerHTML = "Complete";
                nodes.campaignData.surveyNextScheduleTime.innerHTML = "";
                nodes.campaignData.surveyStatus.innerHTML = "Complete";
                return;
            } 

            nodes.campaignSettings.activeStatusWrap.classList.remove("hide");
            nodes.campaignSettings.completeLabel.classList.add("hide");
            nodes.campaignSettings.resendToggle.parentElement.classList.remove("disabled");
            nodes.campaignSettings.googleToggle.parentElement.classList.remove("disabled");
            nodes.campaignSettings.marketingPermissionsToggle.parentElement.classList.remove("disabled");
            nodes.campaignSettings.reviewContactsButton.classList.remove("disabled");
            nodes.campaignData.surveyNextScheduleCard.classList.remove("complete");

            nodes.campaignSettings.activeToggle.addEventListener("change", (event) => {
                setActivePauseStatus(event.target.checked, nodes.campaignSettings.activeLabel);
                editSaveState(false);                
            })

            nodes.campaignSettings.resendToggle.addEventListener("change", (event) => {
                disableInput(event.target, nodes.campaignSettings.resendFrequency);
                editSaveState(false);
            })

            nodes.campaignSettings.googleToggle.addEventListener("change", (event) => {
                disableInput(event.target, nodes.campaignSettings.googleUrlWrap);
                event.target.checked ? nodes.campaignSettings.googleUrlWrap.classList.remove("hide", "disabled") : nodes.campaignSettings.googleUrlWrap.classList.add("hide", "disabled");
                editSaveState(false);
                utilities.setSettingsHeight(nodes);
            })

            nodes.campaignSettings.googleOptionToggles.forEach(toggle => {
                toggle.addEventListener("change", (event) => {
                    editSaveState(false);
                })
            });

            nodes.campaignSettings.marketingPermissionsToggle.addEventListener("change", (event) => {
                editSaveState(false);
            })
        }

        const setActivePauseStatus = (status, node) => {
            if (status) {
                node.innerHTML =  "Active";
                node.classList.add("active");
            } else {
                node.innerHTML =  "Paused";
                node.classList.remove("active");
            }
        }

        const renderCampaign = (data) => {
            
            if(!data) return;

            renderMetricsAndSettings(data);

            nodes.noCampaignsWrap.classList.add("hide");
            nodes.activeCampaign.classList.remove("hide");

            setTimeout(() => {
                utilities.setSettingsHeight(nodes, true);
            }, 100);
            
            if(data.campaign_info.locked === false) {
                let nextDeploymentNote = nodes.noSurveyDeployedWrap.querySelector(".next-deployment");
                let schedule = nodes.noSurveyDeployedWrap.querySelector(".schedule");

                if(data.campaign_info.next_schedule && data.campaign_info.next_schedule.length) {
                    nextDeploymentNote.classList.remove("hide");
                    schedule.innerHTML = moment.parseZone(data.campaign_info.next_schedule).format('MMM DD, YYYY');
                }

                nodes.campaignSettings.editCampaignButton.classList.remove("hide");
                nodes.campaignSettings.lockedControlsWrap.classList.add("hide");
                nodes.noSurveyDeployedWrap.classList.remove("hide");
                nodes.surveyDeployedWrap.classList.add("hide");

                nodes.campaignData.surveyLastSentDate.innerHTML = "N/A"
                nodes.campaignData.surveyLastSentTime.innerHTML = ""

                nodes.campaignSettings.editCampaignButton.setAttribute("href", `${urls["nps:campaign"]()}?campaign=${currentCampaign}`)
                
                return;

            } else {
                nodes.noSurveyDeployedWrap.classList.add("hide");
                nodes.surveyDeployedWrap.classList.remove("hide");
                nodes.campaignSettings.editCampaignButton.classList.add("hide");
                nodes.campaignSettings.lockedControlsWrap.classList.remove("hide");
            }

            if(!searchField) {
                searchField = initSearchField(nodes.searchField, function (value) {
                    campaignSorting.q = customEncodeUri(value);
                    getCampaign(currentCampaign);
                }, {next: campaignSorting.q}  );
            }
            
            if(!pagination) {
                pagination = initPagination(nodes.pagination, function (value) {
                    campaignSorting.page = value;
                    getCampaign(currentCampaign);
                }, campaignSorting);
            }

            pagination.set(data.page_info);

            // re-draw the table if changing contact list type
            if(previousContactList !== campaignSorting.contacts) {
                previousContactList = campaignSorting.contacts;
                createTable();
            }
            
            renderContacts(data);
        }

        // limitNode.querySelector("select").value = filtersData.limit + "";

        function checkForQuestionMark(message) {
            message = message.trim();
            var lastCharacter = message.slice(-1);
            return {
                questionMark: lastCharacter === "?" ? '?' : '',
                text: lastCharacter === "?" ? message.slice(0, -1) : message
            }
        }

        function formatFeedbackPreview () {
            var previewContent = nodes.previewModal.content;
            let feedbackQuestion = previewContent.querySelector("#header.feedback-form__message");
            let scoreSelector = previewContent.querySelector(".custom-select");

            let msgOptions = checkForQuestionMark(feedbackQuestion.innerText)

            let modifiedQuestion = `${msgOptions.text} ${scoreSelector.outerHTML} ${msgOptions.questionMark}`;
            feedbackQuestion.innerHTML = modifiedQuestion;
            
            // hide original score selector
            let template = previewContent.querySelectorAll("#score")[1];
            template.style.display = "none";

            // format drop down
            DD(feedbackQuestion.querySelector(".custom-select"));

            document.querySelector(".feedback-form .feedback-select").classList.remove("hide");
            document.querySelectorAll(".feedback-select .mock-options div")[10].click()
        }

        let createSurveyPreview = () => {
            // steps to pass into preview component
            let previewConfig = {
                steps: [
                        {
                            title: "Email Preview",
                            url: `${urls["nps:preview-email"]()}?campaign=${currentCampaign}`,
                            method: "GET"
                        },
                        {
                            title: "Comment",
                            url: `${urls['nps:preview-feedback']()}?campaign=${currentCampaign}`,
                            method: "GET",
                            callback: formatFeedbackPreview,
                        },
                        {
                            title: "Thank You",
                            url: `${urls['nps:preview-thank-you']()}?campaign=${currentCampaign}`,
                            method: "GET"
                        },
                    ]
                };

            previewModal = preview.create(nodes.previewModal, previewConfig)
        }

        let editSaveState = (disable) => {
            if(disable) {
                nodes.campaignSettings.saveButton.classList.add("disabled");
                saveDisabled = true;
            } else {
                if(saveDisabled) {
                    nodes.campaignSettings.saveButton.classList.remove("disabled");
                    saveDisabled = false;
                }
            }
        }

        return {

            init: function () {

                let globalMetrics = document.querySelector(".metrics-header-wrap.global");
                let globalMetricsHeader = globalMetrics.querySelector("header");

                window.addEventListener('resize', function(event) {
                    utilities.setSettingsHeight(nodes);
                }, true);

                if(browser_storage.getItem("campaign-global-stats-collapse") === "false") {
                    globalMetrics.classList.add("no-transition");
                    globalMetrics.classList.remove("collapse");
                    globalMetrics.classList.remove("no-transition");
                }

                globalMetricsHeader.addEventListener("click", (event) => {
                    if(browser_storage.getItem("campaign-global-stats-collapse") === "false") {
                        browser_storage.setItem("campaign-global-stats-collapse", "true");
                        globalMetrics.classList.add("collapse");
                    } else {
                        browser_storage.setItem("campaign-global-stats-collapse", "false");
                        globalMetrics.classList.remove("collapse");
                    }
                })

                if(nodes.pageWrapper.getAttribute("data-campaigns").trim() === "[]") {
                    nodes.noCampaignsWrap.classList.remove("hide");
                    return;
                }
                
                let DDContactsLimit = DD(nodes.contactsLimitSelector, (value) => {
                    campaignSorting.limit = value;
                    getCampaign(currentCampaign);
                });

                let DDContactListSelector = DD(nodes.contactListSelector, (value) => {
                    campaignSorting.contacts = value;
                    getCampaign(currentCampaign);
                });
        
                let DDCampaignSelector = DD(nodes.campaignSelector, (value) => {
                    campaignSorting = initialSorting;
                    campaignSorting.contacts = 'active';
                    DDContactListSelector.chooseOption('active');
                    getCampaign(value);
                });

                DDRepeatFrequencySelector = DD(nodes.campaignSettings.repeatFrequencySelector, () => { 
                    editSaveState(false);
                });

                DDResendFrequencySelector = DD(nodes.campaignSettings.resendFrequency, () => { 
                    editSaveState(false);
                });
        
                nodes.campaignSettings.saveButton.addEventListener("click", () => {
                    let inputs = document.querySelectorAll(".campaign-settings [data-property]");
                    let settings = {};
        
                    inputs.forEach((input) => {
                        if(input.disabled) {
                            delete settings[input.getAttribute("data-property")];
                        } else {
                            settings[input.getAttribute("data-property")] = input.type === "checkbox" ? input.checked : input.value;
                        }                        
                    });
                    
                    if (settings.resend_frequency) {
                        settings.resend_frequency = settings.resend_frequency * 1;
                    }
                    
                    updateCampaign(settings);
                })

                nodes.campaignSettings.rescheduleLink.addEventListener("click", () => {
                    createdModal.open({
                        class: "reschedule-modal",
                        content: nodes.rescheduleModal.innerHTML,
                        title: "Reschedule Next Survey"
                    }, async function (el) {
                        el.querySelector(".cancel").addEventListener("click", createdModal.close);

                        let originalDeploymentBody = document.querySelector(".original-date-wrap .body");
                        let newDateWrap = document.querySelector(".new-date-wrap");
                        let newDateBody = newDateWrap.querySelector(".body");
                        let deploymentScheduleBody = document.querySelector(".deployment-schedule-wrap .body");
                        let followingDeploymentWrap = document.querySelector(".following-deployment-wrap"); 
                        let followingDeploymentBody = followingDeploymentWrap.querySelector(".body");   
                        let saveButton = document.querySelector(".summary-wrap .button-primary");   
                        let repeat = currentCampaignData.campaign_info.repeat;
                        let updateScheduleToggleWrap = document.querySelector(".calendar-wrap .update-schedule");
                        let updateScheduleToggle = document.querySelector(".calendar-wrap .update-schedule #updateSchedule");
                        let banner = document.querySelector(".calendar-wrap .banner");
                        let selectedDate;
                        let repeatPhrase;
                        let maxCalendarDate;
                        let dateSelected = false;
                        let weekendTooltipCreated = false;
                        let skipWeekdaysFlag = currentCampaignData.campaign_info.skip_weekdays || false; // TO DO - change default value to FALSE when backend is ready

                        let renderCalendarAndDates = () => {
                            if(repeat === 0) {
                                repeatPhrase = "Does not repeat";
                                followingDeploymentWrap.classList.add("hide")
                                updateScheduleToggleWrap.classList.add("hide");
                                updateScheduleToggle.checked = false;
                                banner.innerHTML = "You can pick a new deployment date starting from <strong>tomorrow</strong>";
                                maxCalendarDate = moment().add(1, 'years');
                            } else {
                                repeatPhrase = `Repeats every ${repeat === 1 ? '' : repeat} month${repeat === 1 ? '' : 's'}`;
                                followingDeploymentWrap.classList.remove("hide");
                                updateScheduleToggleWrap.classList.remove("hide");
                                banner.innerHTML = "You can pick a new deployment date between <strong>tomorrow</strong> and the <strong>following deployment date</strong>.";
                                
                                let followingDate = moment.parseZone(currentCampaignData.campaign_info.following_schedule);

                                // if the 'following date' has not already passed, set maxDate on
                                // the calendar to just before the following date
                                if(!followingDate.isBefore(moment())) {
                                    maxCalendarDate = followingDate.subtract(1, 'days');
                                }
                            }

                            originalDeploymentBody.innerHTML = moment.parseZone(currentCampaignData.campaign_info.next_schedule).format('MMMM DD, YYYY');
                            deploymentScheduleBody.innerHTML = repeatPhrase;
                            followingDeploymentBody.innerHTML = moment.parseZone(currentCampaignData.campaign_info.following_schedule).format('MMMM DD, YYYY');

                            const AirDatepickerConstructor = AirDatepicker.default || AirDatepicker; 
                            new AirDatepickerConstructor('#rescheduleCalendar', {
                                visible: true,
                                inline: true,
                                toggleSelected: false,
                                locale: {
                                    ...localeEn.default,
                                    daysMin: ["S", "M", "T", "W", "T", "F", "S"]
                                },
                                dateFormat: "yyyy-MM-dd",
                                startDate: currentCampaignData.campaign_info.next_schedule,
                                minDate: moment().add(1, 'days'),
                                maxDate: maxCalendarDate,
                                onRenderCell({date}) {
                                    let currentScheduleClass = null;
                                    let disabled = false;
                                    let weekendSkipClass = null;

                                    if(date.toLocaleDateString() === moment.parseZone(currentCampaignData.campaign_info.next_schedule).format("M/D/yyyy")) {
                                        currentScheduleClass = "current-schedule";
                                        disabled = true;
                                    }

                                    if(skipWeekdaysFlag === true) {
                                        if(!weekendTooltipCreated) {
                                            // create tooltip
                                            let tooltip = document.createElement("div");
                                            tooltip.classList.add("weekend-tooltip");
                                            tooltip.innerHTML = "Your campaign is configured to skip weekends. Please select a weekday.";
    
                                            document.querySelector(".air-datepicker").appendChild(tooltip);
    
                                            weekendTooltipCreated = true;
                                        }
    
                                        // Disable weekends (satuday = 6, sunday = 0)
                                        if (date.getDay() === 6 || date.getDay() === 0) {
                                            disabled = true;
                                            weekendSkipClass = "weekend-skipped";
                                        }
                                    }

                                    return {
                                        disabled,
                                        classes: `${weekendSkipClass} ${currentScheduleClass}`
                                    }
                                },
                                onSelect: (data) => { 
                                    selectedDate = data.formattedDate;
                                    newDateBody.innerHTML = moment(selectedDate).format('MMMM DD, YYYY');
                                    newDateBody.classList.remove("warning");
                                    // remove and re-add updated class for visible transition each time
                                    newDateWrap.classList.remove("updated");
                                    setTimeout(() => {
                                        newDateWrap.classList.add("updated");
                                    }, 200)
                                    saveButton.classList.remove("disabled");
    
                                    if(updateScheduleToggle.checked) {
                                        getFollowingDeploymentDate(selectedDate)
                                    }
                                    
                                    dateSelected = true;
                                },
                                onFocus: () => {
                                    let tooltip = document.querySelector(".weekend-tooltip");
                                    if(tooltip) {
                                        document.querySelector(".weekend-tooltip").classList.remove("active");
                                    }
                                }
                            })

                            let tooltip = document.querySelector(".weekend-tooltip");
                            
                            document.querySelector(".air-datepicker").addEventListener("click", (event) => {
                                if(event.target.classList.contains("weekend-skipped")){
                                    tooltip.classList.add("active");
                                }
                            })
                        }

                        let getFollowingDeploymentDate = (deploymentDate) => {
                            fetch(urls['nps:get-next-date'](currentCampaign) + "?" + new URLSearchParams({
                                "start_date": deploymentDate,
                                "update_schedule": true,
                            }), {
                                method: 'GET',
                            })
                            .then(response => response.json())
                            .then(response => {
                                if(response.following_date !== currentCampaignData.campaign_info.following_schedule) {
                                    followingDeploymentBody.innerHTML = moment(response.following_date).format('MMMM DD, YYYY');
                                    followingDeploymentWrap.classList.remove("updated");
                                    saveButton.classList.remove("disabled");
                                    setTimeout(() => {
                                        followingDeploymentWrap.classList.add("updated");
                                    }, 200)
                                }
                            })
                        }

                        // initial calendar render
                        renderCalendarAndDates();

                        updateScheduleToggle.addEventListener("change", (event) => {
                            if(event.target.checked) {
                                getFollowingDeploymentDate(dateSelected ? selectedDate : currentCampaignData.campaign_info.next_schedule);
                            } else {
                                followingDeploymentWrap.classList.remove("updated");
                                followingDeploymentBody.innerHTML = moment(currentCampaignData.campaign_info.following_schedule).format('MMMM DD, YYYY');
                            }
                        })

                        saveButton.addEventListener("click", () => {
                            saveButton.classList.add("loading");

                            fetch(urls['nps:save-new-date'](currentCampaign), {
                                method: 'POST',
                                headers:{
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                    'X-CSRFToken': csrfToken
                                }, 
                                body: new URLSearchParams({
                                    "start_date": dateSelected ? selectedDate : currentCampaignData.campaign_info.next_schedule,
                                    "update_schedule": updateScheduleToggle.checked,
                                })
                            })
                            .then(() => {
                                saveButton.classList.remove("loading");
                                createdModal.close();
                                getCampaign(currentCampaign, () => {
                                    let successBanner = document.querySelector(".schedule-success-banner");
                                    successBanner.classList.add("show");
                                    setTimeout(() => {
                                        successBanner.classList.remove("show");
                                    }, 3000)
                                });                                
                            })
                        })
                    });
                })
        
                nodes.settingsToggle.addEventListener("click", (event) => {
                    event.currentTarget.classList.contains("active") ? event.currentTarget.classList.remove("active") : event.currentTarget.classList.add("active");
                    let settings = nodes.campaignSettings.parent;
                    settings.classList.contains("hide") ? settings.classList.remove("hide") : settings.classList.add("hide");

                    document.querySelectorAll(".campaign-settings .close-edit").forEach(node => {
                        if(!node.parentElement.classList.contains("hide")){
                            node.click();
                        }
                    })
                })
        
                nodes.campaignSettings.deleteButton.addEventListener("click", () => {
                    createdModal.open({
                        content: nodes.deleteModalTemplate.innerHTML,
                        title: nodes.deleteModalTemplate.getAttribute("data-title")
                    }, function (el) {
                        el.querySelector(".campaign-name").innerHTML = `<strong>${nodes.campaignSettings.name.innerText}<strong>`;

                        el.querySelector(".cancel").addEventListener("click", createdModal.close);
                        el.querySelector(".confirm").addEventListener("click", () => {
                            deleteCampaign();
                        })
                    });
                })

                nodes.campaignSettings.viewSurveyButton.addEventListener("click", () => {
                    previewModal.open();
                })
        
                document.querySelectorAll(".campaign-settings .edit-icon").forEach(icon => {
                    icon.addEventListener("click", () => {
                        let targetName = icon.getAttribute("data-name");
                        document.querySelector(`[data-name="${targetName}"] .static-wrap`).classList.add("hide");
                        document.querySelector(`[data-name="${targetName}"] .input-wrap`).classList.remove("hide");
                        document.querySelector(`[data-property="${targetName}"]`).value = document.querySelector(`[data-name="${targetName}"] .static-wrap`).getAttribute("data-original-value");
                        document.querySelector(`[data-property="${targetName}"]`).focus();
                        editSaveState(false);
                    });
                });

                document.querySelectorAll(".campaign-settings .close-edit").forEach(icon => {
                    icon.addEventListener("click", () => {
                        let targetName = icon.getAttribute("data-name");

                        document.querySelector(`[data-name="${targetName}"] .static-wrap`).classList.remove("hide");
                        document.querySelector(`[data-name="${targetName}"] .input-wrap`).classList.add("hide");
                        
                        let input = document.querySelector(`[data-property="${targetName}"]`);
                        input.value = document.querySelector(`[data-name="${targetName}"] .static-wrap`).getAttribute("data-original-value");
                    })
                })

                DDContactsLimit.reset();
                DDCampaignSelector.reset();
                DDRepeatFrequencySelector.reset();
                DDResendFrequencySelector.reset();
                DDContactListSelector.reset();
                createTable();

                let lastCampaign =  browser_storage.getItem("last-visited-campaign");
                if(lastCampaign && lastCampaign.length) {
                    getCampaign(lastCampaign);
                    DDCampaignSelector.chooseOption(lastCampaign);
                } else {
                    getLatestCampaign();
                }
            }
        }
    }
);